(function () {
  'use strict';

  /*
   * ============================================================
   * DELASCO AFFILIATE / REFERRAL TRACKING
   * ============================================================
   *
   * This version intentionally DOES NOT mutate the Shopify cart
   * during normal storefront page loads.
   *
   * Attribution is:
   *
   * 1. Captured from the inbound URL.
   * 2. Stored in first-party cookies for 30 days.
   * 3. Assigned a unique Referral Click ID.
   * 4. Added to the Shopify cart form only when the customer
   *    actually submits the cart / proceeds to checkout.
   *
   * It does NOT:
   *
   * - call /cart/update.js
   * - modify collection links
   * - modify product links
   * - rewrite URLs
   * - modify browser history
   * - intercept Fast Simon navigation
   * - observe or modify Fast Simon grids
   *
   * ============================================================
   */


  /*
   * ------------------------------------------------------------
   * CONFIGURATION
   * ------------------------------------------------------------
   */

  var REF_PARAM = 'ref';
  var CAMPAIGN_PARAM = 'aff_campaign';

  var ATTRIBUTION_DAYS = 30;


  /*
   * Cookie names
   */

  var COOKIE_REF = 'delasco_aff_ref';
  var COOKIE_CAMPAIGN = 'delasco_aff_campaign';
  var COOKIE_CLICK_ID = 'delasco_aff_click_id';
  var COOKIE_CLICK_DATE = 'delasco_aff_click_date';


  /*
   * Shopify cart attribute labels
   *
   * These become the labels shown in:
   *
   * Order > Additional details
   */

  var FIELD_PARTNER = 'Referral Partner';
  var FIELD_CAMPAIGN = 'Referral Campaign';
  var FIELD_CLICK_ID = 'Referral Click ID';
  var FIELD_CLICK_DATE = 'Referral Click Date';



  /*
   * ============================================================
   * HELPERS
   * ============================================================
   */


  /*
   * Read a URL query parameter.
   */

  function readParam(name) {
    try {
      return new URLSearchParams(
        window.location.search
      ).get(name);
    } catch (e) {
      return null;
    }
  }



  /*
   * Sanitize affiliate values.
   */

  function clean(value) {
    if (!value) {
      return null;
    }

    return String(value)
      .replace(/[^a-zA-Z0-9_-]/g, '')
      .slice(0, 40);
  }



  /*
   * Write first-party cookie.
   */

  function writeCookie(name, value, days) {
    try {
      var expires = new Date();

      expires.setTime(
        expires.getTime() +
        (days * 24 * 60 * 60 * 1000)
      );

      document.cookie =
        name + '=' +
        encodeURIComponent(value || '') +
        ';expires=' + expires.toUTCString() +
        ';path=/' +
        ';SameSite=Lax' +
        ';Secure';

    } catch (e) {
      /*
       * Affiliate tracking must never interfere
       * with storefront functionality.
       */
    }
  }



  /*
   * Read first-party cookie.
   */

  function readCookie(name) {
    try {
      var cookies = document.cookie
        ? document.cookie.split(';')
        : [];

      var prefix = name + '=';

      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();

        if (cookie.indexOf(prefix) === 0) {
          return decodeURIComponent(
            cookie.substring(prefix.length)
          );
        }
      }

    } catch (e) {
      return null;
    }

    return null;
  }



  /*
   * Generate unique Referral Click ID.
   */

  function generateClickId() {

    /*
     * Preferred modern method.
     */

    try {
      if (
        window.crypto &&
        typeof window.crypto.randomUUID === 'function'
      ) {
        return window.crypto.randomUUID();
      }
    } catch (e) {}


    /*
     * Older-browser fallback.
     */

    return (
      'clk_' +
      Date.now().toString(36) +
      '_' +
      Math.random().toString(36).slice(2, 12)
    );
  }



  /*
   * Determine whether this page load was a refresh,
   * history navigation, or normal navigation.
   */

  function getNavigationType() {

    try {
      if (
        window.performance &&
        typeof window.performance.getEntriesByType === 'function'
      ) {

        var entries =
          window.performance.getEntriesByType('navigation');

        if (
          entries &&
          entries.length &&
          entries[0].type
        ) {
          return entries[0].type;
        }
      }
    } catch (e) {}


    /*
     * Legacy fallback.
     */

    try {
      if (
        window.performance &&
        window.performance.navigation
      ) {

        if (
          window.performance.navigation.type === 1
        ) {
          return 'reload';
        }

        if (
          window.performance.navigation.type === 2
        ) {
          return 'back_forward';
        }
      }
    } catch (e) {}


    return 'navigate';
  }



  /*
   * Was the visitor referred from another page
   * on the same Delasco domain?
   */

  function cameFromSameOrigin() {

    if (!document.referrer) {
      return false;
    }

    try {
      var referrerUrl =
        new URL(document.referrer);

      return (
        referrerUrl.origin ===
        window.location.origin
      );

    } catch (e) {
      return false;
    }
  }



  /*
   * ============================================================
   * 1. READ INBOUND AFFILIATE INFORMATION
   * ============================================================
   */

  var incomingRef =
    clean(
      readParam(REF_PARAM)
    );


  var incomingCampaign =
    clean(
      readParam(CAMPAIGN_PARAM)
    ) || '';


  var navigationType =
    getNavigationType();



  /*
   * ============================================================
   * 2. READ EXISTING ATTRIBUTION
   * ============================================================
   */

  var storedPartner =
    clean(
      readCookie(COOKIE_REF)
    );


  var storedCampaign =
    clean(
      readCookie(COOKIE_CAMPAIGN)
    ) || '';


  var storedClickId =
    readCookie(COOKIE_CLICK_ID);


  var storedClickDate =
    readCookie(COOKIE_CLICK_DATE);



  /*
   * ============================================================
   * 3. DETERMINE WHETHER THIS IS A NEW AFFILIATE CLICK
   * ============================================================
   */

  var isNewAffiliateClick = false;


  if (incomingRef) {

    /*
     * Reloading the original affiliate URL should not generate
     * another commissionable click.
     */

    var isReload =
      navigationType === 'reload';


    /*
     * Browser Back / Forward should not generate another click.
     */

    var isHistoryNavigation =
      navigationType === 'back_forward';


    /*
     * Protect against an app/theme carrying ?ref= forward to
     * another internal Delasco page.
     */

    var isInternalContinuation =
      cameFromSameOrigin() &&
      storedPartner === incomingRef &&
      storedCampaign === incomingCampaign &&
      !!storedClickId;


    if (
      !isReload &&
      !isHistoryNavigation &&
      !isInternalContinuation
    ) {
      isNewAffiliateClick = true;
    }
  }



  /*
   * ============================================================
   * 4. CAPTURE NEW AFFILIATE CLICK
   * ============================================================
   */

  if (isNewAffiliateClick) {

    var newClickId =
      generateClickId();


    var newClickDate =
      new Date().toISOString();


    /*
     * Last affiliate click wins.
     */

    writeCookie(
      COOKIE_REF,
      incomingRef,
      ATTRIBUTION_DAYS
    );


    writeCookie(
      COOKIE_CAMPAIGN,
      incomingCampaign,
      ATTRIBUTION_DAYS
    );


    writeCookie(
      COOKIE_CLICK_ID,
      newClickId,
      ATTRIBUTION_DAYS
    );


    writeCookie(
      COOKIE_CLICK_DATE,
      newClickDate,
      ATTRIBUTION_DAYS
    );


    /*
     * Update our in-memory values immediately.
     */

    storedPartner =
      incomingRef;


    storedCampaign =
      incomingCampaign;


    storedClickId =
      newClickId;


    storedClickDate =
      newClickDate;
  }



  /*
   * ============================================================
   * 5. DETERMINE ACTIVE REFERRAL
   * ============================================================
   */

  var partner =
    storedPartner;


  /*
   * There is no affiliate attribution.
   *
   * Exit immediately.
   *
   * NOTHING else on the storefront is touched.
   */

  if (!partner) {
    return;
  }



  var campaign =
    storedCampaign || '';


  var clickId =
    storedClickId;


  var clickDate =
    storedClickDate;



  /*
   * Backwards compatibility:
   *
   * If an older cookie exists without a Click ID,
   * generate one once.
   */

  if (!clickId) {

    clickId =
      generateClickId();

    writeCookie(
      COOKIE_CLICK_ID,
      clickId,
      ATTRIBUTION_DAYS
    );
  }



  /*
   * Same fallback for Click Date.
   */

  if (!clickDate) {

    clickDate =
      new Date().toISOString();

    writeCookie(
      COOKIE_CLICK_DATE,
      clickDate,
      ATTRIBUTION_DAYS
    );
  }



  /*
   * ============================================================
   * 6. CART FORM HELPERS
   * ============================================================
   *
   * IMPORTANT:
   *
   * We are NOT updating the Shopify cart here.
   *
   * We simply place hidden fields into Shopify's existing cart
   * form at the moment that form is submitted.
   *
   * Shopify then receives the attributes as part of the normal
   * cart / checkout submission.
   * ============================================================
   */


  /*
   * Determine whether a form is actually the Shopify cart form.
   *
   * Matches:
   *
   * /cart
   * /en/cart
   * /fr/cart
   * etc.
   *
   * Does NOT match:
   *
   * /cart/add
   * /cart/change
   * /cart/update
   */

  function isCartForm(form) {

    if (
      !form ||
      form.tagName !== 'FORM'
    ) {
      return false;
    }


    var action =
      form.getAttribute('action');


    if (!action) {
      return false;
    }


    try {

      var actionUrl =
        new URL(
          action,
          window.location.origin
        );


      var pathname =
        actionUrl.pathname
          .replace(/\/+$/, '');


      return (
        pathname === '/cart' ||
        pathname.slice(-5) === '/cart'
      );

    } catch (e) {

      /*
       * Very conservative fallback.
       */

      var cleanAction =
        action
          .split('?')[0]
          .replace(/\/+$/, '');


      return (
        cleanAction === '/cart' ||
        cleanAction.slice(-5) === '/cart'
      );
    }
  }



  /*
   * Add or update one hidden Shopify cart attribute.
   */

  function upsertCartAttribute(
    form,
    fieldName,
    fieldValue
  ) {

    var inputName =
      'attributes[' +
      fieldName +
      ']';


    var existingInputs =
      form.querySelectorAll(
        'input[name]'
      );


    var input =
      null;


    for (
      var i = 0;
      i < existingInputs.length;
      i++
    ) {

      if (
        existingInputs[i].name ===
        inputName
      ) {

        input =
          existingInputs[i];

        break;
      }
    }



    /*
     * Attribute does not exist yet.
     */

    if (!input) {

      input =
        document.createElement(
          'input'
        );


      input.type =
        'hidden';


      input.name =
        inputName;


      input.setAttribute(
        'data-delasco-affiliate-attribute',
        fieldName
      );


      form.appendChild(
        input
      );
    }



    /*
     * Always update to current attribution.
     */

    input.value =
      fieldValue || '';
  }



  /*
   * Add all four referral fields to a Shopify cart form.
   */

  function stampCartForm(form) {

    if (!isCartForm(form)) {
      return;
    }


    upsertCartAttribute(
      form,
      FIELD_PARTNER,
      partner
    );


    upsertCartAttribute(
      form,
      FIELD_CAMPAIGN,
      campaign
    );


    upsertCartAttribute(
      form,
      FIELD_CLICK_ID,
      clickId
    );


    upsertCartAttribute(
      form,
      FIELD_CLICK_DATE,
      clickDate
    );
  }



  /*
   * ============================================================
   * 7. STAMP ONLY WHEN THE CUSTOMER ACTUALLY USES THE CART
   * ============================================================
   */


  /*
   * Capture normal cart-form submission.
   *
   * The event is NOT prevented.
   * The event is NOT stopped.
   * Navigation behaves exactly as Shopify intended.
   */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;


      if (
        form &&
        isCartForm(form)
      ) {

        stampCartForm(
          form
        );
      }

    },
    true
  );



  /*
   * Shopify/Dawn commonly uses a Checkout button attached to
   * the cart form.
   *
   * Add the attributes immediately before the normal click
   * proceeds.
   *
   * Again:
   *
   * - preventDefault() is NOT used
   * - stopPropagation() is NOT used
   * - the checkout click is NOT delayed
   */

  document.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;


      if (
        !target ||
        typeof target.closest !== 'function'
      ) {
        return;
      }


      var checkoutButton =
        target.closest(
          '[name="checkout"]'
        );


      if (
        !checkoutButton
      ) {
        return;
      }


      var form =
        checkoutButton.form;


      if (
        form &&
        isCartForm(form)
      ) {

        stampCartForm(
          form
        );
      }

    },
    true
  );


})();